import type { ReactNode } from "react";

interface ListingTemplateProps {
  header: ReactNode;
  featured: ReactNode;
  controls: ReactNode;
  content: ReactNode;
}

export function ListingTemplate({ header, featured, controls, content }: ListingTemplateProps) {
  return (
    <div className="mx-auto w-full max-w-7xl px-4 pt-4 sm:px-6">
      <header className="mb-5 sm:mb-6">{header}</header>
      <section className="mb-10 space-y-6 sm:space-y-8">
        {featured}
        {controls}
        {content}
      </section>
    </div>
  );
}
